export default __webpack_public_path__ + "static/media/img_download.dbd84d4d.svg";